import { createContext, useContext, useEffect, useState } from "react";
import { fetchBranding } from "@/lib/api";

const DEFAULT_BRAND = {
  brand_name: "CasperDomains",
  login_overline: "Control Room",
  login_headline: "Precision domain acquisition.",
  login_subtext:
    "Schedule snipes, register through TransIP, Spaceship, Dynadot, and auto-list wins with instant Stripe checkout. All from one dashboard.",
};

const BrandingContext = createContext(DEFAULT_BRAND);

export function BrandingProvider({ children }) {
  const [brand, setBrand] = useState(() => {
    try {
      const cached = localStorage.getItem("sniper_branding");
      return cached ? { ...DEFAULT_BRAND, ...JSON.parse(cached) } : DEFAULT_BRAND;
    } catch {
      return DEFAULT_BRAND;
    }
  });
  useEffect(() => {
    fetchBranding()
      .then((b) => {
        setBrand(b);
        localStorage.setItem("sniper_branding", JSON.stringify(b));
      })
      .catch(() => {});
  }, []);
  return <BrandingContext.Provider value={brand}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext);
